/* Wishlist: hearts on product cards, the header heart with a count, and the popup (snippets/wishlist.liquid).
   Saved products are product handles in localStorage, so the list stays in this browser.
   A share link (?wishlist=handle,handle) opens the popup showing that list, read-only. */
(() => {
  const KEY = 'as-wishlist';
  const dialog = document.getElementById('as-wishlist');
  if (!dialog) return;

  const $ = (sel) => dialog.querySelector(sel);
  const grid = $('[data-wl-grid]');
  const empty = $('[data-wl-empty]');
  const clearBtn = $('[data-wl-clear]');
  const saveSharedBtn = $('[data-wl-save-shared]');
  const sharedNote = $('[data-wl-shared-note]');
  const loginNote = $('[data-wl-login]');
  const heading = $('[data-wl-heading]');
  const shareBtn = $('[data-wl-share]');
  const toast = $('[data-wl-toast]');
  const moneyFormat = dialog.dataset.moneyFormat || '${{amount}}';
  const txt = (key, fallback) => dialog.dataset[key] || fallback;
  const productCache = new Map();
  let sharedHandles = null; // set while showing someone else's shared list

  /* ---------- storage ---------- */
  function read() {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch {
      return [];
    }
  }

  // kept in memory too, so the hearts still work for this visit when storage is blocked (private mode)
  let saved = read();

  function list() {
    return saved;
  }

  function write(next) {
    saved = [...new Set(next)];
    try {
      localStorage.setItem(KEY, JSON.stringify(saved));
    } catch {
      /* storage blocked */
    }
    sync();
  }

  function toggle(handle) {
    const on = !saved.includes(handle);
    write(on ? [handle, ...saved] : saved.filter((h) => h !== handle));
    return on;
  }

  /* ---------- hearts and header count ---------- */
  function sync() {
    const savedSet = new Set(list());
    document.querySelectorAll('[data-wl-toggle]').forEach((btn) => {
      const on = savedSet.has(btn.dataset.wlToggle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-saved', on);
      const label = btn.getAttribute('aria-label') || '';
      btn.setAttribute('aria-label', on ? label.replace(/^Add (.*) to wishlist$/, 'Remove $1 from wishlist') : label.replace(/^Remove (.*) from wishlist$/, 'Add $1 to wishlist'));
    });
    document.querySelectorAll('[data-wl-count]').forEach((el) => {
      el.textContent = savedSet.size;
      el.hidden = savedSet.size === 0;
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      const heart = event.target.closest('[data-wl-toggle]');
      if (heart) {
        // hearts sit inside product-card links: keep the click from opening the product
        event.preventDefault();
        event.stopPropagation();
        const on = toggle(heart.dataset.wlToggle);
        heart.classList.remove('is-pop');
        void heart.offsetWidth;
        if (on) heart.classList.add('is-pop');
        return;
      }
      if (event.target.closest('[data-wl-open]')) {
        event.preventDefault();
        open();
      }
    },
    true
  );

  // cards added later (filters, infinite scroll, quick add) get the right heart state too
  new MutationObserver(() => {
    clearTimeout(sync.t);
    sync.t = setTimeout(sync, 60);
  }).observe(document.body, { childList: true, subtree: true });

  // another tab changed the list
  window.addEventListener('storage', (e) => {
    if (e.key !== KEY) return;
    saved = read();
    sync();
  });

  /* ---------- popup ---------- */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const withCommas = (value, thousands, decimal) => {
      const [whole, frac] = value.split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac !== undefined ? decimal + frac : '');
    };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, kind) => {
      switch (kind) {
        case 'amount_no_decimals':
          return withCommas(Math.round(cents / 100).toString(), ',', '.');
        case 'amount_with_comma_separator':
          return withCommas(amount, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withCommas(Math.round(cents / 100).toString(), '.', ',');
        default:
          return withCommas(amount, ',', '.');
      }
    });
  }

  function sizedImage(src, width) {
    if (!src) return '';
    try {
      const url = new URL(src, location.origin);
      url.searchParams.set('width', width);
      return url.toString();
    } catch {
      return src;
    }
  }

  function fetchProduct(handle) {
    if (!productCache.has(handle)) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      productCache.set(
        handle,
        fetch(`${root}products/${encodeURIComponent(handle)}.js`)
          // 404 = the product was deleted or unpublished; anything else (offline, etc.) is just skipped this time
          .then((r) => (r.ok ? r.json() : r.status === 404 ? 'missing' : null))
          .catch(() => null)
      );
    }
    return productCache.get(handle);
  }

  // "Parisian Fever Eau de Parfum (100ml) – Inspired by …" -> "Parisian Fever", matching the product cards
  function shortTitle(title) {
    const t = String(title || '');
    const m = t.match(/^(.*?)\s+(Eau de Parfum|淡香精)/);
    return m ? m[1] : t;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  async function render() {
    const handles = sharedHandles || list();
    const readOnly = Boolean(sharedHandles);

    heading.textContent = readOnly ? txt('tShared', 'Shared Wishlist') : txt('tMine', 'My Wishlist');
    sharedNote.hidden = !readOnly;
    if (loginNote) loginNote.hidden = readOnly;
    saveSharedBtn.hidden = !readOnly || handles.length === 0;
    clearBtn.hidden = readOnly || handles.length === 0;
    shareBtn.hidden = readOnly || handles.length === 0;
    empty.hidden = handles.length > 0;

    grid.innerHTML = handles.map(() => '<li class="as-wl__card is-loading" aria-hidden="true"></li>').join('');

    const products = await Promise.all(handles.map(fetchProduct));
    const html = products
      .map((p, i) => {
        if (!p || p === 'missing') return '';
        const handle = handles[i];
        const image = p.featured_image
          ? `<img src="${escapeHtml(sizedImage(p.featured_image, 480))}" alt="${escapeHtml(p.title)}" loading="lazy" width="240" height="240">`
          : '';
        const price = p.price_varies ? txt('tFrom', 'from __PRICE__').replace('__PRICE__', formatMoney(p.price_min)) : formatMoney(p.price);
        const remove = readOnly
          ? ''
          : `<button type="button" class="as-wl__remove" data-wl-remove="${escapeHtml(handle)}" aria-label="${escapeHtml(txt('tRemove', 'Remove __TITLE__ from wishlist').replace('__TITLE__', p.title))}">
               <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9 3h6l1 2h4v2H4V5h4zM6 9h12l-1 12H7z"/></svg>
             </button>`;
        return `<li class="as-wl__card">
            <a class="as-wl__link" href="${escapeHtml(p.url)}">
              <span class="as-wl__name" title="${escapeHtml(p.title)}">${escapeHtml(shortTitle(p.title))}</span>
              <span class="as-wl__img">${image}</span>
              <span class="as-wl__price">${escapeHtml(price)}</span>
            </a>
            ${remove}
          </li>`;
      })
      .join('');
    grid.innerHTML = html;

    // drop products that no longer exist from the saved list
    if (!readOnly) {
      const missing = handles.filter((_, i) => products[i] === 'missing');
      if (missing.length) write(list().filter((h) => !missing.includes(h)));
    }
    if (!html) {
      empty.hidden = false;
      clearBtn.hidden = true;
      shareBtn.hidden = true;
    }
  }

  function open(shared) {
    sharedHandles = shared || null;
    showToast('');
    render();
    if (!dialog.open) dialog.showModal();
  }

  function close() {
    dialog.close();
  }

  function showToast(text) {
    toast.textContent = text;
    clearTimeout(showToast.t);
    if (text) showToast.t = setTimeout(() => (toast.textContent = ''), 3000);
  }

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog || event.target.closest('[data-wl-close]')) {
      close();
      return;
    }
    const remove = event.target.closest('[data-wl-remove]');
    if (remove) {
      write(list().filter((h) => h !== remove.dataset.wlRemove));
      render();
    }
  });

  clearBtn.addEventListener('click', () => {
    write([]);
    render();
  });

  saveSharedBtn.addEventListener('click', () => {
    write([...(sharedHandles || []), ...list()]);
    history.replaceState(null, '', location.pathname + location.hash);
    open();
    showToast(txt('tAdded', 'Added to your wishlist'));
  });

  shareBtn.addEventListener('click', async () => {
    const handles = list();
    if (!handles.length) return;
    const url = `${location.origin}/?wishlist=${handles.map(encodeURIComponent).join(',')}`;
    const data = { title: 'My Aroma Sense wishlist', text: 'Take a look at my Aroma Sense favourites', url };
    if (navigator.share) {
      try {
        await navigator.share(data);
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      showToast(txt('tCopied', 'Link copied'));
    } catch {
      window.prompt('Copy this link to share your wishlist:', url);
    }
  });

  /* ---------- start ---------- */
  sync();
  const shared = new URLSearchParams(location.search).get('wishlist');
  if (shared) {
    const handles = shared.split(',').map((h) => h.trim()).filter(Boolean).slice(0, 50);
    if (handles.length) open(handles);
  }
})();
